import { ensureDownloaded } from 'serviceWorker/channelServers/entitySource';
import * as users from 'serviceWorker/db/users/users';
import { UserEntity } from 'shared/domain/user/types/entity';
import { userSource } from './userSource';

/** Every user, once the first download of the users ended (it starts when missing). */
export async function getUsersSynchronized(): Promise<UserEntity[]> {
  await ensureDownloaded(userSource.storage);
  return users.get();
}

export async function getCurrentUsers(): Promise<UserEntity[]> {
  return users.get();
}
